import VideoBanner from './VideoBanner';

export default VideoBanner;
